module.exports = __webpack_public_path__ + "media/images/banners/banner1-911c911d1da739f1136948e0cee096a7.jpg";